/**
 * Kazoo timestamps are Gregorian seconds (seconds since year 0), not Unix.
 * Every `created_from`, `pvt_created`, `timestamp` and CDR field is one.
 * Convert at the API boundary and nowhere else.
 */
export const GREGORIAN_UNIX_OFFSET = 62_167_219_200;

export function gregorianToDate(seconds: number): Date {
  return new Date((seconds - GREGORIAN_UNIX_OFFSET) * 1000);
}

export function dateToGregorian(date: Date): number {
  return Math.floor(date.getTime() / 1000) + GREGORIAN_UNIX_OFFSET;
}

export function nowGregorian(): number {
  return dateToGregorian(new Date());
}
